import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = { class: "fab-icon fab-icon-pulse" }
const _hoisted_3 = {
  key: 0,
  class: "fab-texts"
}

import { ref, computed } from "vue";
import { UserTracking } from "@/utils/UserTracking";

const iconSize = "large";

export default /*@__PURE__*/_defineComponent({
  __name: 'AIAssistantFab',
  props: {
  opened: {
    type: Boolean,
    default: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
  isTransitioning: {
    type: Boolean,
    default: false,
  },
  isProcessingMinimized: {
    type: Boolean,
    default: false,
  },
  showAsBanner: {
    type: Boolean,
    default: false,
  },
  isRemoteRecording: {
    type: Boolean,
    default: false,
  },
  token: null,
  userId: null,
  patientId: null,
  licenseId: null,
  bookingId: null,
  pms: null,
  displayMode: String,
},
  emits: ["click", "finalize-recording"],
  setup(__props, { emit: __emit }) {

/**
 * AIAssistantFab.vue - Floating Action Button
 *
 * Main entry point for the AI Assistant. Displays as a floating button
 * that expands on hover and triggers the assistant flow on click.
 */
const props = __props;

const emit = __emit;

const isHovered = ref(false);
const hasTrackedHover = ref(false);

const onHover = () => {
  isHovered.value = true;

  if (!hasTrackedHover.value) {
    UserTracking.trackEvent("element_visibility_changed", {
      element: "noa widget",
      action: "show element",
      page_category: "patients",
      page_section: "patient profile",
      page_type: "",
    });
    hasTrackedHover.value = true;
  }
};
const onLeave = () => {
  isHovered.value = false;
  hasTrackedHover.value = false;
};

const handleClick = (event: Event) => {
  console.log("[AIAssistantFab] handleClick called");
  emit("click", event);
};

const fabStateClass = computed(() => {
  // Remote recording takes priority
  if (props.isRemoteRecording) {
    return "fab-recording-remote";
  }

  // Show banner style when showAsBanner is true (GrowthBook feature flag)
  if (props.showAsBanner) {
    return "fab-banner";
  }

  // Normal hover behavior
  if (isHovered.value) {
    const classes = ["fab-hover"];
    if (props.active) classes.push("fab-active");
    if (props.isProcessingMinimized) classes.push("fab-processing");
    return classes.join(" ");
  }

  return props.isProcessingMinimized ? "fab-default fab-processing-collapsed" : "fab-default";
});

const isExpanded = computed(() => isHovered.value || props.showAsBanner);
const isProcessingMinimized = computed(() => props.isProcessingMinimized);
const fabTitle = computed(() => {
  if (props.isTransitioning) return "Processando...";
  if (props.isProcessingMinimized) return "Processando...";
  if (props.showAsBanner) return "Utilize a IA para gerar as anotações para seu prontuário!";
  return props.active ? "Atendimento Iniciado" : "Noa Notes";
});
const fabSubtitle = computed(() => {
  if (props.isTransitioning) return "Clique para ver";
  if (props.isProcessingMinimized) return "Clique para ver";
  if (props.showAsBanner) return "Clique agora e comece a transcrever!";
  return "Anotar com IA";
});
const iconColor = computed(() => (isExpanded.value ? "#00897B" : "#fff"));

return (_ctx: any,_cache: any) => {
  const _component_w_icon = _resolveComponent("w-icon")!
  const _component_w_spinner = _resolveComponent("w-spinner")!
  const _component_w_text = _resolveComponent("w-text")!

  return (_openBlock(), _createElementBlock("div", {
    id: "ai-assistant-fab",
    class: _normalizeClass([fabStateClass.value]),
    onMouseover: onHover,
    onMouseleave: onLeave,
    onClick: handleClick,
    "aria-expanded": __props.opened
  }, [
    (__props.isRemoteRecording)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_component_w_icon, {
              name: "smart",
              size: "large",
              color: "#00897B"
            })
          ]),
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"fab-remote-text\" data-v-05ec95d7><span class=\"fab-remote-line\" data-v-05ec95d7>Gravação em andamento</span></div><div class=\"fab-waveform\" data-v-05ec95d7><span class=\"bar\" data-v-05ec95d7></span><span class=\"bar\" data-v-05ec95d7></span><span class=\"bar\" data-v-05ec95d7></span><span class=\"bar\" data-v-05ec95d7></span><span class=\"bar\" data-v-05ec95d7></span></div>", 2)),
          _createElementVNode("button", {
            class: "fab-go-btn",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('finalize-recording')), ["stop"]))
          }, "Ir para gravação")
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", {
            class: _normalizeClass(['fab-icon', { 'fab-icon-bg': isExpanded.value, 'fab-icon-processing': isProcessingMinimized.value }])
          }, [
            (__props.isTransitioning)
              ? (_openBlock(), _createBlock(_component_w_spinner, {
                  key: 0,
                  size: "large"
                }))
              : _createCommentVNode("", true),
            (isProcessingMinimized.value)
              ? (_openBlock(), _createBlock(_component_w_spinner, {
                  key: 1,
                  class: "processing-spinner",
                  size: "large"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_w_icon, {
              name: "smart",
              size: iconSize,
              color: iconColor.value
            }, null, 8, ["color"])
          ], 2),
          (isExpanded.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_w_text, {
                  class: "fab-title",
                  type: "sectionHeading"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(fabTitle.value), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_w_text, {
                  class: "fab-subtitle",
                  type: "bodyEmphasis"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(fabSubtitle.value), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ], 42, _hoisted_1))
}
}

})